import type { HomeDashPanelModel } from "../panel/home.dash.panel.model";

/** Dashboard section `typeId` values from {@link DashLangMap} (`section.type`). */
export const HomeDashSectionTypeId = {
    Regular: 1,
    Toolbox: 2,
} as const;

/** Dashboard column (toolbox or regular) from {@link DashService.get}. */
export type HomeDashSectionModel = {
    sectionId?: number;
    typeId: number;
    panels: HomeDashPanelModel[];
};

/** Root payload from {@link DashService.get} / {@link DashService.reset}. */
export type HomeDashPageModel = {
    sections: HomeDashSectionModel[];
};
